/**
 * Collection Filters — Drawer UI + AJAX filter submission
 *
 * Opens/closes the filter drawer, submits the filter form via fetch()
 * to avoid full page reloads, and updates the product grid + active filters.
 */
(function () {
  'use strict';

  var drawer = document.getElementById('FilterDrawer');
  var form = document.getElementById('CollectionFiltersForm');
  var applyBtn = document.getElementById('FilterApply');
  if (!drawer || !form) return;

  /* ── Drawer open/close ── */

  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.body.classList.add('drawer-open');
    /* Trap focus */
    var firstFocusable = drawer.querySelector('button, input, select, details summary');
    if (firstFocusable) firstFocusable.focus();
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
  }

  /* Open triggers */
  document.querySelectorAll('[data-filter-open]').forEach(function (btn) {
    btn.addEventListener('click', openDrawer);
  });

  /* Close triggers */
  document.querySelectorAll('[data-filter-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  /* Escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  /* ── Apply button — submits form via fetch ── */

  function submitFilters() {
    var formData = new FormData(form);
    var params = new URLSearchParams();

    /* Build params, skip empty price inputs */
    for (var pair of formData.entries()) {
      if (pair[1] !== '' && pair[1] !== undefined) {
        params.append(pair[0], pair[1]);
      }
    }

    var url = form.action + '?' + params.toString();

    closeDrawer();

    /* Show loading state */
    var grid = document.getElementById('CollectionProductGrid');
    if (grid) grid.style.opacity = '0.5';

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        /* Swap product grid */
        var newGrid = doc.getElementById('CollectionProductGrid');
        if (newGrid && grid) {
          grid.innerHTML = newGrid.innerHTML;
          grid.style.opacity = '';
        }

        /* Swap active filters */
        var newActive = doc.getElementById('ActiveFilters');
        var currentActive = document.getElementById('ActiveFilters');
        if (currentActive && newActive) {
          currentActive.outerHTML = newActive.outerHTML;
        } else if (newActive) {
          /* Insert before grid */
          grid.parentNode.insertBefore(newActive, grid);
        } else if (currentActive) {
          currentActive.remove();
        }

        /* Update product count */
        var newCount = doc.getElementById('CollectionCount');
        var currentCount = document.getElementById('CollectionCount');
        if (newCount && currentCount) {
          currentCount.textContent = newCount.textContent;
        }

        /* Update filter badge */
        var newBtn = doc.querySelector('.collection-filter-btn');
        var currentBtn = document.querySelector('.collection-filter-btn');
        if (newBtn && currentBtn) {
          currentBtn.innerHTML = newBtn.innerHTML;
        }

        /* Update infinite scroll */
        var newScroll = doc.querySelector('.infinite-scroll');
        var currentScroll = document.querySelector('.infinite-scroll');
        if (newScroll && currentScroll) {
          currentScroll.outerHTML = newScroll.outerHTML;
        } else if (currentScroll && !newScroll) {
          currentScroll.remove();
        }

        /* Update URL */
        history.pushState(null, '', url);

        /* Re-bind active filter tag clicks */
        bindActiveFilterClicks();
      })
      .catch(function () {
        /* Fallback: full page navigation */
        window.location.href = url;
      });
  }

  if (applyBtn) {
    applyBtn.addEventListener('click', submitFilters);
  }

  /* ── Active filter tags: click to remove (AJAX) ── */

  function bindActiveFilterClicks() {
    document.querySelectorAll('.active-filter-tag, .active-filters__clear').forEach(function (tag) {
      tag.addEventListener('click', function (e) {
        e.preventDefault();
        var url = this.href;
        var grid = document.getElementById('CollectionProductGrid');
        if (grid) grid.style.opacity = '0.5';

        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            /* Swap product grid */
            var newGrid = doc.getElementById('CollectionProductGrid');
            if (newGrid && grid) {
              grid.innerHTML = newGrid.innerHTML;
              grid.style.opacity = '';
            }

            /* Swap active filters */
            var newActive = doc.getElementById('ActiveFilters');
            var currentActive = document.getElementById('ActiveFilters');
            if (currentActive && newActive) {
              currentActive.outerHTML = newActive.outerHTML;
            } else if (currentActive) {
              currentActive.remove();
            }

            /* Update product count */
            var newCount = doc.getElementById('CollectionCount');
            var currentCount = document.getElementById('CollectionCount');
            if (newCount && currentCount) {
              currentCount.textContent = newCount.textContent;
            }

            /* Update filter badge */
            var newBtn = doc.querySelector('.collection-filter-btn');
            var currentBtn = document.querySelector('.collection-filter-btn');
            if (newBtn && currentBtn) {
              currentBtn.innerHTML = newBtn.innerHTML;
            }

            /* Update the drawer form with fresh state */
            var newDrawer = doc.getElementById('FilterDrawer');
            var currentDrawerBody = document.querySelector('.filter-drawer__body');
            var newDrawerBody = newDrawer ? newDrawer.querySelector('.filter-drawer__body') : null;
            if (newDrawerBody && currentDrawerBody) {
              currentDrawerBody.innerHTML = newDrawerBody.innerHTML;
            }

            /* Update infinite scroll */
            var newScroll = doc.querySelector('.infinite-scroll');
            var currentScroll = document.querySelector('.infinite-scroll');
            if (newScroll && currentScroll) {
              currentScroll.outerHTML = newScroll.outerHTML;
            } else if (currentScroll && !newScroll) {
              currentScroll.remove();
            }

            history.pushState(null, '', url);
            bindActiveFilterClicks();
          })
          .catch(function () {
            window.location.href = url;
          });
      });
    });
  }

  /* Initial bind */
  bindActiveFilterClicks();

  /* Handle browser back/forward */
  window.addEventListener('popstate', function () {
    window.location.reload();
  });
})();
